<ion-header>
  <div class="pdf-header">
    <ion-row>
      <ion-col size="3" class="ion-justify-content-center">
        <img class="icon" draggable="false">
      </ion-col>
      <ion-col size="8">
        <p *ngIf="showPDF" class="name"> {{fileName}}</p>
      </ion-col>
      <ion-col size="1">
        <ion-icon 
          class="icon-close pointer" 
          name="close-circle-outline" 
          (click)="goBack()">
        </ion-icon>
      </ion-col>
    </ion-row>  
  </div>
  </ion-header>
  <ion-content>
    <div class="container-div">
    <ng-container *ngIf="showPDF">
          <pdf-viewer [src]="pdfSrc"
            [render-text]="true"
            [show-borders]="true"          
          ></pdf-viewer>
    </ng-container>  
  </div>
  </ion-content>